


























































import { Component, Emit, Prop, PropSync, Ref } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import { AtomTextField } from '@/components/atoms'
import { IButtonToggleItem } from '@/components/molecules/ButtonToggle/ButtonToggle.type'
import { ButtonToggle } from '@/components/molecules/ButtonToggle'
import { Prefix } from '@/types'
import { InputCollectionNo } from '@/components/molecules/InputCollectionNo'

export interface BibliographyIntegrationSearchConditionItem {
  collectionNo: {
    input: string
    errorMessage: string
  }
  prefix: {
    input: string
    errorMessage: string
  }
  bibliographyId: {
    input: string
    errorMessage: string
  }
}

export const defaultBibliographyIntegrationSearchConditionItem = (): BibliographyIntegrationSearchConditionItem => ({
  collectionNo: {
    input: '',
    errorMessage: ''
  },
  prefix: {
    input: '',
    errorMessage: ''
  },
  bibliographyId: {
    input: '',
    errorMessage: ''
  }
})

const PREFIX_TOGGLE_ITEMS: IButtonToggleItem[] = [
  { value: Prefix.Real, text: 'R 物理' },
  { value: Prefix.Set, text: 'S 集合' }
]

const BIBLIOGRAPHY_MAX_DIGITS: number = 10

@Component({
  components: { InputCollectionNo, ButtonToggle }
})
export default class BibliographyIntegrationSearchConditions extends ComponentVue {
  @Ref()
  inputCollectionNo!: InputCollectionNo

  @Ref()
  bibliographyIdTextField!: AtomTextField

  @PropSync('input', {
    type: Object,
    required: true
  })
  inputItem!: BibliographyIntegrationSearchConditionItem

  @Prop({
    type: Boolean,
    default: false
  })
  disabledAll!: boolean

  @Prop({
    type: Boolean,
    default: false
  })
  isSelectPrefix!: boolean

  get bibliographyIdMask(): string {
    return '#'.repeat(BIBLIOGRAPHY_MAX_DIGITS)
  }

  get prefixToggleItems(): IButtonToggleItem[] {
    return PREFIX_TOGGLE_ITEMS
  }

  existsErrorMessage(errorMessage: string): boolean {
    return !!errorMessage
  }

  focusCollectionId(): void {
    this.inputCollectionNo.focus()
  }

  focusBibliographyId(): void {
    this.bibliographyIdTextField.atomTextField.focus()
  }

  resetErrorMessage(obj: any): void {
    obj.errorMessage = ''
  }

  @Emit('search')
  onClickSearch(): void {}

  @Emit('determine:collection-no')
  onDetermineCollectionNo(): void {}
}
